import React from 'react';

import { Skeleton as AvatarSkeleton } from '@atlaskit/avatar';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import {
	AvatarItemContainer,
	ReportingLinesChartCard,
	ReportsList,
	VerticalChartLine,
} from './styles';

const styles = cssMap({
	wrapper: {
		height: '50px',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: token('space.050', '4px'),
	},
});

export function ReportingLinesSkeleton(): React.JSX.Element {
	return (
		<>
			<UserCardSkeleton />
			<VerticalChartLine />
			<UserCardSkeleton />
			<VerticalChartLine />
			<UserCardSkeleton />
			<VerticalChartLine />
			<ReportsList>
				{Array.from({ length: 8 }, (_, i) => (
					<UserCardSkeleton key={i} />
				))}
			</ReportsList>
		</>
	);
}

export function UserCardSkeleton(): React.JSX.Element {
	return (
		<ReportingLinesChartCard selected={false}>
			<Box xcss={styles.wrapper}>
				<AvatarItemContainer>
					<AvatarSkeleton />
				</AvatarItemContainer>
			</Box>
		</ReportingLinesChartCard>
	);
}
